import { Weblab } from '@amzn/katal-weblab';
import WeblabId from 'src/weblab/weblabId';
import WEBLAB_LIST from './weblabList';

type WeblabMap = { [key in WeblabId]: Weblab };
const WEBLAB_MAP: WeblabMap = Object.values(WeblabId).reduce(
  (res, weblabId) => ({
    ...res,
    [weblabId]: WEBLAB_LIST.find((weblab) => weblab.id === weblabId)!,
  }),
  {} as WeblabMap,
);
export default WEBLAB_MAP;
